import type { AnchorHTMLAttributes, ElementType, HTMLAttributeAnchorTarget, HTMLAttributes, Ref } from 'react';
import type { LinkComponent } from '@tanstack/react-router';
import { clsx } from 'clsx';
import styles from './base-link.module.scss';

export type LinkElementType =
  // normal anchor: <a />
  | ElementType<AnchorHTMLAttributes<HTMLAnchorElement>>
  // @tanstack/react-router: <Link />
  | LinkComponent<'a'>;

const SECURITY_PROPS_BY_TARGET: Partial<Record<HTMLAttributeAnchorTarget, AnchorHTMLAttributes<HTMLAnchorElement>>> = {
  _blank: { rel: 'noopener noreferrer' },
};

export type BaseLinkUnderlineCondition = 'always' | 'hover' | 'never';

export interface BaseLinkProps extends Omit<HTMLAttributes<HTMLAnchorElement>, 'href'> {
  preload?: 'intent' | 'render' | boolean;
  LinkElement?: LinkElementType;
  ref?: Ref<HTMLAnchorElement>;
  state?: any;
  target?: HTMLAttributeAnchorTarget;
  to: string;
  underline?: BaseLinkUnderlineCondition;
}

export function BaseLink({ children, className, LinkElement = 'a', preload, state, target, to, ref, ...rest }: BaseLinkProps) {
  return (
    <LinkElement
      className={clsx(styles.link, className)}
      href={LinkElement === 'a' ? to : undefined}
      // @ts-expect-error
      preload={LinkElement === 'a' ? undefined : preload}
      ref={ref}
      state={LinkElement === 'a' ? undefined : state}
      target={target}
      to={LinkElement === 'a' ? undefined : to}
      {...rest}
      {...SECURITY_PROPS_BY_TARGET[target || '_self']}
    >
      {children}
    </LinkElement>
  );
}
